import axios from 'axios'

export default {
    namespaced: true,
    state:{
        options: {
            pages: '', // число операций на странице
            id: ''
        },
    },
    getters:{
        getnumberOfPages(state){
            return state.options.pages;
        },
    },
    mutations:{
        numberOfPages(state, payload){
            state.options.pages = payload
        },
        idItemOptions(state, payload){
            state.options.id = payload
        },
    },
    actions:{
        numberOfPages: function({commit})
        {
            BX24.callMethod('entity.get', {}, function(result)
            {
                if(result.error())
                {
                    let alert = 'Ошибка проверки хранилища'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    let store = result.data()
                    let storeflag = false
                    for (var i=0;i<store.length; i++){
                        if (store[i]['ENTITY'] == "settings"){
                            storeflag = true
                            break
                        }
                    }
                    if (storeflag) {
                        numberOfPageGet()
                    } else createStoreSettings()
                }
            })

            // создаение хранилища Settings
            function createStoreSettings()
            {
                BX24.callMethod('entity.add',
                {
                    "entity": "settings",
                    "NAME":"settings",
                    "access":{
                        AU: "W"
                    }
                },
                function(result)
                {
                    if(result.error())
                    {
                        let alert = 'Ошибка создания хранилища'
                        dispatch('alertInfo', alert, {root: true})
                        console.log(result.error())
                    }
                    else
                    {
                        BX24.callMethod('entity.item.add',
                        {
                            ENTITY: 'settings',
                            NAME: 'options'
                        },
                        function(result2)
                        {
                            if(result2.error())
                            {
                                let alert = 'Ошибка создания элемента хранилища'
                                dispatch('alertInfo', alert, {root: true})
                                console.log(result2.error())
                            }
                            else
                            {
                                numberOfPageGet()
                            }
                        })
                    }
                })
            }

            function numberOfPageGet(){
                let id
                let quantity

                BX24.callMethod('entity.item.get',
                {
                    ENTITY: 'settings'
                },
                function(result)
                {
                    if(result.error())
                    {
                        let alert = 'Ошибка вызова хринилища (счета)'
                        dispatch('alertInfo', alert, { root: true })
                        console.log(result.error())
                    }
                    else
                    {
                        id = result.data()[0]['ID']
                        if(result.data()[0]['PROPERTY_VALUES']){
                            quantity = result.data()[0]['PROPERTY_VALUES']['numberOfPages']
                        } else {
                            quantity = 10

                            BX24.callMethod('entity.item.property.add',
                            {
                                ENTITY: 'settings',
                                NAME: 'numberOfPages',
                                PROPERTY: 'numberOfPages',
                                TYPE: 'S'
                            },
                            function(result2)
                            {
                                if(result2.error())
                                {
                                    let alert = 'Ошибка добавления свойства в настройки'
                                    dispatch('alertInfo', alert, {root: true})
                                    console.log(result2.error())
                                }
                                else
                                {
                                    BX24.callMethod('entity.item.update',
                                    {
                                        ID: id,
                                        ENTITY: 'settings',
                                        PROPERTY_VALUES:
                                        {
                                            numberOfPages: quantity
                                        }
                                    },
                                    function(result3)
                                    {
                                        if(result3.error())
                                        {
                                            let alert = 'Ошибка изменения отображения количества операций на странице'
                                            dispatch('alertInfo', alert, {root: true})
                                            console.log(result3.error())
                                        }
                                        else
                                        {
                                            console.log('ok')
                                        }
                                    })
                                }
                            })
                        }
                        commit("numberOfPages",quantity)
                        commit("idItemOptions",id)
                    }
                })

                }
        },
            // изменяет количество оперций на странице
        changeNumberOfPages: function({state, commit}, change){
            let id = state.options.id

            BX24.callMethod('entity.item.update',
            {
                ID: id,
                ENTITY: 'settings',
                PROPERTY_VALUES:
                {
                    numberOfPages: change
                }
            },
            function(result)
            {
                if(result.error())
                {
                    let alert = 'Ошибка изменения отображения количества операций на странице'
                    dispatch('alertInfo', alert, {root: true})
                    console.log(result.error())
                }
                else
                {
                    commit("numberOfPages",change)
                }
            })
        },
    }
}